import React from "react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./Styles.css";

const Gallery = () => {
  const [headingRef, headingVisible] = useScrollAnimation({ threshold: 0.3 });
  const [gridRef, gridVisible] = useScrollAnimation({ threshold: 0.2 });

  const images = [
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYJZt4c6SHyEwW7QUYAdBIFvP6RMpeRblpOA&s", alt: "Gallery 1", className: "img1" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvjZsla1O4QvCKg6paa-p27cSoq2YPghkFfA&s", alt: "Gallery 2", className: "img2" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_oQTHZrPnn7calTFZUdVkzU8AIhW_rsZoVA&s", alt: "Gallery 3", className: "img3" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrYZuw6KlNq99zrMWsKPQMF65IBpiNw1TtJQ&s", alt: "Gallery 4", className: "img4" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRavK-W9rOCAJu1WKHuokbWUiUO8Kp0EZVyEg&s", alt: "Gallery 5", className: "img5" },
    { src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr7gS8NhYsaigyfmyQncEFOvO0hwgoymAz_A&s", alt: "Gallery 6", className: "img6" },
  ];

  return (
    <section className="gallery-section">
      <div className="container">
        {/* HEADER — eyebrow LEFT, title RIGHT (same as Services) */}
        <div
          ref={headingRef}
          className={`section-header fade-in-up ${headingVisible ? 'visible' : ''}`}
        >
          <div className="sh-label">
            <span className="eyebrow">Gallery</span>
          </div>
          <div className="sh-title">
            <h2 className="section-title">WE WELCOME YOU TO OUR FAMILY</h2>
          </div>
        </div>
      </div>

      <div className="gallery-content">
        <div
          ref={gridRef}
          className={`gallery-grid stagger-children ${gridVisible ? 'visible' : ''}`}
        >
          {images.map((img, i) => (
            <img
              key={i}
              src={img.src}
              alt={img.alt}
              className={`gallery-image ${img.className}`}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
